import React from 'react';

import Header from '../layout/header';
import Footer from '../layout/footer';
import Leftmenu from '../Patients/leftmenu';
import Profiledetail from '../Patients/profiledetail';
import PatientAppointmentslist from '../Patients/patientAppointmentslist';
import Patientright from '../Patients/patientright';

function patientAppointments() {
	return (
		<div className="coverWraper">
			<Header />
			<div className="contentWraper contentWraperScroll patientAppointmentWrapper">
				<Leftmenu />
				<div className="rightSection">
					<Profiledetail />
					<div className="practiceManagementWrap">
						<div className="row practiceManagementRow">
							<div className="col-lg-8 col-md-12 practiceLeftSection">
								<PatientAppointmentslist />
							</div>
							<div className="col-lg-4 col-md-12 practiceRightSection">
								<Patientright />
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default patientAppointments;
